module.exports = __webpack_public_path__ + "img/sld_scb_10_t1_red.d8085585.svg";